import React from "react";
import { motion } from "framer-motion";
import { portfolioData } from "../data/portfolioData";

const KeyAchievements = () => {
  return (
    <section id="key-achievements" className="scroll-mt-24 py-14">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <h2 className="text-3xl font-bold text-slate-900">Key Achievements</h2>
        <div className="mt-8 grid gap-5 sm:grid-cols-2">
          {portfolioData.keyAchievements.map((achievement, index) => (
            <motion.article
              key={achievement}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.45, delay: index * 0.1 }}
              whileHover={{
                y: -4,
                boxShadow: "0 10px 22px rgba(79, 70, 229, 0.12)",
                borderColor: "rgba(79, 70, 229, 0.45)",
              }}
              className="rounded-xl border border-slate-200 bg-white/80 p-6"
            >
              <p className="text-sm leading-relaxed text-slate-700">{achievement}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KeyAchievements;
